<template>
  <div class="wrapper">
    <h1>Sorry, this video is currently unavailable.</h1>
    <p>For installation support, visit <a href="https://www.spectrum.net/selfinstallhelp">spectrum.net/selfinstallhelp</a></p>
    <div class="images">
      <div class="imgWrapper"><img class="img_tv" :src="getImgUrl('Support_TV.png')" alt="TV"></div>
      <div class="imgWrapper"><img class="img_wifi" :src="getImgUrl('Support_WiFi.png')" alt="WiFi"></div>
      <div class="imgWrapper"><img class="img_phone" :src="getImgUrl('Support_WiFi_Phone.png')" alt="Phone"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyEquipmentComponent',
  methods:{
    getImgUrl(name) {
      let images = require.context('../assets/EmptyEquipment/')
      return images('./' + name )
    },
  }
}
</script>

<style scoped>
  .wrapper{
    margin: 125px auto 0;
  }
  h1,p{
    text-align: center;
  }
  p{
    font-weight: bold;
    font-size: 24px;
    margin-top: 15px;
  }
  a{
    text-decoration: none;
    color:#0099D8;
  }
  a:hover{
    text-decoration: underline;
  }


  .images{
    text-align: center;
    margin-top: 25px;
    display: flex;
    justify-content: center;
  }
  img{
    max-width: 100%;
  }
  .img_tv{
      margin-right: 10px;
  }
  .img_wifi{
    max-width: 70%;
  }
  .imgWrapper{
    display: flex;
    height: 80px;
    width: 80px;
    justify-content: center;
      align-items: center;
  } 
</style>